<template>
  <div class="page-wrapper thoivu-wrapper" :class="{'is-mobile': isMobile}">
    <div class="content container-fluid">

      <!-- Header -->
      <div class="page-header header-sticky">
        <div class="row align-items-center">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="mb-2">
              <h3 class="page-title mb-1">
                Lao động <span class="badge badge-info">THỜI VỤ</span>
              </h3>
              <ul class="breadcrumb mb-0 small">
                <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
                <li class="breadcrumb-item active">Lao động thời vụ</li>
              </ul>
            </div>

            <div class="d-flex align-items-center flex-wrap mb-2">
              <div class="input-group input-group-sm mr-2 mb-2" style="width: 220px;">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="filter.keyword"
                  placeholder="Tên/SĐT…"
                  @keyup.enter="fetchList(0)"
                />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" @click="fetchList(0)">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>

              <select
                class="form-control form-control-sm mr-2 mb-2"
                style="width:140px"
                v-model="filter.status"
                @change="fetchList(0)"
              >
                <option :value="null">Tất cả</option>
                <option :value="1">Đang làm</option>
                <option :value="0">Ngưng</option>
              </select>

              <button class="btn btn-success btn-sm mr-2 mb-2" @click="openCreate">
                <i class="fa fa-plus mr-1"></i> Thêm lao động
              </button>

              <button class="btn btn-outline-primary btn-sm mr-2 mb-2" @click="fetchList()" :disabled="loading">
                <i class="fa fa-refresh mr-1"></i> Tải lại
              </button>

              <!-- Xuất Excel -->
              <button class="btn btn-outline-success btn-sm mb-2" @click="exportExcel" :disabled="exporting || loading">
                <i :class="exporting ? 'fa fa-spinner fa-spin mr-1' : 'fa fa-file-excel-o mr-1'"></i>
                {{ exporting ? 'Đang xuất…' : 'Xuất Excel' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- List Desktop -->
      <div v-if="!isMobile" class="card">
        <div class="card-body table-responsive p-0">
          <table class="table table-hover table-striped mb-0">
            <thead>
              <tr>
                <th style="width:56px;" class="text-center">#</th>
                <th>Họ và tên</th>
                <th style="width:160px;">SĐT</th>
                <th style="width:120px;">Trạng thái</th>
                <th style="width:180px;">Ngày tạo</th>
                <th style="width:180px;">Ngày sửa</th>
                <th style="width:200px;" class="text-right">Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it,idx) in list" :key="it.id">
                <td class="text-center">{{ idx + 1 + page*size }}</td>
                <td class="font-weight-600">
                  <div class="d-flex align-items-center">
                    <span class="avatar avatar-xs mr-2">
                      <span class="avatar-fallback">{{ initials(it.hoTen) }}</span>
                    </span>
                    <div class="d-inline-flex flex-column">
                      <span>{{ it.hoTen }}</span>
                      <small class="text-muted text-monospace">#{{ it.id }}</small>
                    </div>
                  </div>
                </td>
                <td>{{ it.soDienThoai || '—' }}</td>
                <td>
                  <span :class="it.trangThai===1?'badge badge-success':'badge badge-light'">
                    {{ it.trangThai===1 ? 'Đang làm' : 'Ngưng' }}
                  </span>
                </td>
                <td>{{ fmtDT(it.ngayTao) }}</td>
                <td>{{ fmtDT(it.ngaySua) }}</td>
                <td class="text-right">
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-primary" @click="openEdit(it)">Sửa</button>
                    <button class="btn btn-outline-secondary" @click="openDonGia(it)">Đơn giá</button>
                    <button class="btn btn-outline-dark" @click="openTaiLieu(it)">Tài liệu</button>
                    <button class="btn btn-outline-danger" @click="del(it)">Xóa</button>
                  </div>
                </td>
              </tr>
              <tr v-if="list.length===0">
                <td colspan="7" class="text-center text-muted">Không có dữ liệu</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pager -->
        <div class="card-footer d-flex align-items-center justify-content-between">
          <div class="small text-muted">Tổng: {{ total.toLocaleString("vi-VN") }}</div>
          <div>
            <button class="btn btn-light btn-sm mr-1" :disabled="page===0" @click="fetchList(page-1)">‹</button>
            <span class="mx-1 small">Trang {{ page+1 }}</span>
            <button class="btn btn-light btn-sm ml-1" :disabled="(page+1)*size>=total" @click="fetchList(page+1)">›</button>
          </div>
        </div>
      </div>

      <!-- Mobile cards -->
      <div v-else>
        <div class="ld-card" v-for="it in list" :key="it.id">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="avatar avatar-sm mr-2">
                <span class="avatar-fallback">{{ initials(it.hoTen) }}</span>
              </span>
              <div>
                <div class="font-weight-600 name-ellipsis">{{ it.hoTen }}</div>
                <div class="small text-monospace text-muted">#{{ it.id }}</div>
              </div>
            </div>
            <span :class="it.trangThai===1?'badge badge-success':'badge badge-light'">
              {{ it.trangThai===1 ? 'Đang làm' : 'Ngưng' }}
            </span>
          </div>
          <div class="small mt-2">
            <div><i class="fa fa-phone mr-1"></i>{{ it.soDienThoai || '—' }}</div>
            <div class="text-muted">Tạo: {{ fmtDT(it.ngayTao) }}</div>
          </div>
          <div class="btn-row mt-2">
            <button class="btn btn-outline-primary btn-sm" @click="openEdit(it)">Sửa</button>
            <button class="btn btn-outline-secondary btn-sm" @click="openDonGia(it)">Đơn giá</button>
            <button class="btn btn-outline-dark btn-sm" @click="openTaiLieu(it)">Tài liệu</button>
            <button class="btn btn-outline-danger btn-sm" @click="del(it)">Xóa</button>
          </div>
        </div>

        <!-- Pager mobile -->
        <div class="d-flex align-items-center justify-content-center mt-2">
          <button class="btn btn-light btn-sm mr-1" :disabled="page===0" @click="fetchList(page-1)">‹</button>
          <span class="mx-1 small">Trang {{ page+1 }}</span>
          <button class="btn btn-light btn-sm ml-1" :disabled="(page+1)*size>=total" @click="fetchList(page+1)">›</button>
        </div>
      </div>
    </div>

    <!-- === Modals (thông tin, đơn giá, tài liệu) giữ nguyên như trước === -->
    <!-- Modal: Thông tin LĐ -->
    <div class="modal custom-modal fade show" v-if="form.open" style="display:block;" role="dialog" aria-modal="true">
      <div class="modal-dialog" :class="isMobile ? 'modal-fullscreen' : 'modal-dialog-centered modal-lg'">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ form.id ? 'Cập nhật lao động' : 'Thêm lao động' }}</h5>
            <button type="button" class="close" @click="form.open=false"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-12 col-md-8">
                <label>Họ và tên</label>
                <input type="text" class="form-control" v-model.trim="form.hoTen" />
              </div>
              <div class="form-group col-12 col-md-4">
                <label>SĐT</label>
                <input type="text" class="form-control" v-model.trim="form.soDienThoai" placeholder="09x…" />
              </div>
              <div class="form-group col-12 col-md-4">
                <label>Trạng thái</label>
                <select class="form-control" v-model="form.trangThai">
                  <option :value="1">Đang làm</option>
                  <option :value="0">Ngưng</option>
                </select>
              </div>
              <div class="form-group col-12">
                <label>Ghi chú</label>
                <textarea rows="2" class="form-control" v-model.trim="form.ghiChu"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-light" @click="form.open=false">Đóng</button>
            <button class="btn btn-primary" :disabled="saving" @click="saveLd">
              <i class="fa fa-save mr-1"></i>Lưu
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Đơn giá -->
    <div class="modal custom-modal fade show" v-if="donGia.open" style="display:block;" role="dialog" aria-modal="true">
      <div class="modal-dialog" :class="isMobile ? 'modal-fullscreen' : 'modal-dialog-centered modal-lg'">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Đơn giá — <span class="text-primary">{{ donGia.ld?.hoTen }}</span></h5>
            <button type="button" class="close" @click="donGia.open=false"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info small">
              <ul class="mb-0 pl-3">
                <li><b>Hành chính</b>: 1 ngày = 1.0 công = <i>đơn giá ngày HC</i> (mỗi buổi = 0.5 công).</li>
                <li><b>Chủ nhật</b>: tách lương theo <i>đơn giá ngày CN</i> (mỗi buổi CN = 0.5).</li>
                <li><b>Tăng ca</b>: tính theo giờ (thường & CN).</li>
              </ul>
            </div>
            <div class="form-row">
              <div class="form-group col-12 col-md-6">
                <label>Đơn giá ngày HC</label>
                <input type="text" class="form-control" v-model.trim="donGia.form.donGiaHanhChinhNgay" placeholder="vd: 350000" />
              </div>
              <div class="form-group col-12 col-md-6">
                <label>Đơn giá ngày CN</label>
                <input type="text" class="form-control" v-model.trim="donGia.form.donGiaChuNhatNgay" placeholder="vd: 450000" />
              </div>
              <div class="form-group col-12 col-md-6">
                <label>Đơn giá Tăng ca (giờ)</label>
                <input type="text" class="form-control" v-model.trim="donGia.form.donGiaTangCaGio" placeholder="vd: 36000" />
              </div>
              <div class="form-group col-12 col-md-6">
                <label>Đơn giá Tăng ca Chủ nhật (giờ)</label>
                <input type="text" class="form-control" v-model.trim="donGia.form.donGiaTangCaCnGio" placeholder="vd: 50000" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-light" @click="donGia.open=false">Đóng</button>
            <button class="btn btn-primary" :disabled="saving" @click="saveDonGia">
              <i class="fa fa-save mr-1"></i>Lưu
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Tài liệu -->
    <div class="modal custom-modal fade show" v-if="taiLieu.open" style="display:block;" role="dialog" aria-modal="true">
      <div class="modal-dialog" :class="isMobile ? 'modal-fullscreen' : 'modal-dialog-centered modal-xl'">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Tài liệu — <span class="text-primary">{{ taiLieu.ld?.hoTen }}</span>
            </h5>
            <button type="button" class="close" @click="taiLieu.open=false"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <!-- Upload -->
            <div class="card mb-3">
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-12 col-md-5">
                    <label>Tiêu đề</label>
                    <input type="text" class="form-control" v-model.trim="taiLieu.form.tieuDe" placeholder="CMND/CCCD, Hợp đồng…" />
                  </div>
                  <div class="form-group col-12 col-md-5">
                    <label>Ghi chú</label>
                    <input type="text" class="form-control" v-model.trim="taiLieu.form.ghiChu" placeholder="Thông tin thêm…" />
                  </div>
                  <div class="form-group col-12 col-md-2">
                    <label>&nbsp;</label>
                    <div>
                      <input type="file" class="form-control-file" multiple @change="onPickFiles" />
                    </div>
                  </div>
                </div>
                <button
                  class="btn btn-primary"
                  :disabled="uploading || !pickedFiles.length || !taiLieu.form.tieuDe"
                  @click="doUpload"
                >
                  <i class="fa fa-upload mr-1"></i> Tải & lưu
                </button>
                <span v-if="uploading" class="text-muted ml-2">
                  <i class="fa fa-spinner fa-spin"></i> Đang tải…
                </span>
              </div>
            </div>

            <!-- List -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th style="width:56px;" class="text-center">#</th>
                    <th>Tiêu đề</th>
                    <th>File</th>
                    <th>Ghi chú</th>
                    <th style="width:180px;">Ngày tải</th>
                    <th style="width:120px;" class="text-right">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(d,i) in taiLieu.list" :key="d.id">
                    <td class="text-center">{{ i+1 }}</td>
                    <td class="font-weight-600">{{ d.tieuDe }}</td>
                    <td>
                      <a :href="d.fileUrl" target="_blank" rel="noopener">
                        {{ shortName(d.fileUrl) }}
                      </a>
                    </td>
                    <td>{{ d.ghiChu || '—' }}</td>
                    <td>{{ fmtDT(d.ngayTao) }}</td>
                    <td class="text-right">
                      <div class="btn-group btn-group-sm">
                        <button class="btn btn-outline-secondary" @click="preview(d)">Xem</button>
                        <button class="btn btn-outline-danger" @click="delTaiLieu(d)">Xóa</button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="taiLieu.list.length===0">
                    <td colspan="6" class="text-center text-muted">Chưa có tài liệu</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Image lightbox -->
            <vue-easy-lightbox
              :visible="lightbox.visible"
              :imgs="lightbox.imgs"
              :index="lightbox.index"
              @hide="lightbox.visible=false"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from "../api";
import Swal from "sweetalert2";
import VueEasyLightbox from "vue-easy-lightbox";
import XLSX from "xlsx-js-style";

export default {
  name: "ThoivuLaoDong",
  components: { VueEasyLightbox },
  data(){
    return {
      // list
      loading:false,
      list:[],
      total:0,
      page:0, size:20,
      filter:{ keyword:"", status:1 },

      // form LD
      form:{ open:false, id:null, hoTen:"", soDienThoai:"", trangThai:1, ghiChu:"" },
      saving:false,

      // Export state
      exporting:false,

      // Đơn giá
      donGia:{
        open:false,
        ld:null,
        form:{
          idThoivuLd:null,
          donGiaHanhChinhNgay:"",   // BigDecimal string
          donGiaChuNhatNgay:"",
          donGiaTangCaGio:"",
          donGiaTangCaCnGio:""
        }
      },

      // Tài liệu
      taiLieu:{
        open:false,
        ld:null,
        list:[],
        form:{ tieuDe:"", ghiChu:"" }
      },
      pickedFiles:[],
      uploading:false,
      lightbox:{ visible:false, imgs:[], index:0 },

      // responsive
      isMobile:false
    };
  },
  mounted(){
    this.onResize();
    window.addEventListener('resize', this.onResize, {passive:true});
    this.fetchList();
  },
  beforeUnmount(){
    window.removeEventListener('resize', this.onResize);
  },
  methods:{
    // ====== fetch list ======
    async fetchList(p=null){
      if (p!==null) this.page=p;
      this.loading=true;
      try{
        const params = {
          keyword: this.filter.keyword || "",
          status: this.filter.status,
          page: this.page,
          size: this.size
        };
        const { data } = await api.get("/api/thoivu/lao-dong", { params });
        const content = data?.data?.content ?? [];
        this.list = content;
        this.total = data?.data?.totalElements ?? content.length;
      }catch(e){
        console.error(e);
        this.list=[]; this.total=0;
        this.alertUser("Không tải được danh sách","error");
      }finally{
        this.loading=false;
      }
    },

    // ====== CRUD LD ======
    openCreate(){
      this.form = { open:true, id:null, hoTen:"", soDienThoai:"", trangThai:1, ghiChu:"" };
    },
    async openEdit(row){
      try{
        const { data } = await api.get(`/api/thoivu/lao-dong/${row.id}`);
        const it = data?.data || row;
        this.form = {
          open:true,
          id: it.id,
          hoTen: it.hoTen || "",
          soDienThoai: it.soDienThoai || "",
          trangThai: it.trangThai ?? 1,
          ghiChu: it.ghiChu || ""
        };
      }catch{
        this.form = {
          open:true,
          id: row.id,
          hoTen: row.hoTen,
          soDienThoai: row.soDienThoai,
          trangThai: row.trangThai,
          ghiChu: row.ghiChu
        };
      }
    },
    async saveLd(){
      if (!this.form.hoTen?.trim()){
        this.alertUser("Nhập họ tên","warning");
        return;
      }
      this.saving=true;
      try{
        const payload = {
          hoTen: this.form.hoTen?.trim(),
          soDienThoai: this.form.soDienThoai?.trim() || null,
          trangThai: this.form.trangThai,
          ghiChu: this.form.ghiChu?.trim() || null
        };
        if (this.form.id){
          await api.put(`/api/thoivu/lao-dong/${this.form.id}`, payload);
        }else{
          await api.post(`/api/thoivu/lao-dong`, payload);
        }
        await this.fetchList();
        this.toastOk("Đã lưu");
        this.form.open=false;
      }catch(e){
        console.error(e);
        this.alertUser("Lưu lỗi","error");
      }finally{
        this.saving=false;
      }
    },
    async del(row){
      const cfm = await Swal.fire({icon:"warning",title:`Xóa #${row.id}?`,text:"Không thể hoàn tác",showCancelButton:true,confirmButtonText:"Xóa",cancelButtonText:"Hủy"});
      if (!cfm.isConfirmed) return;
      try{
        await api.delete(`/api/thoivu/lao-dong/${row.id}`);
        await this.fetchList();
        this.toastOk("Đã xóa");
      }catch(e){
        console.error(e); this.alertUser("Xóa lỗi","error");
      }
    },

    // ====== Đơn giá (Cấu hình lương) ======
    async openDonGia(row){
      this.donGia.ld = row;
      this.donGia.form = {
        idThoivuLd: row.id,
        donGiaHanhChinhNgay:"", donGiaChuNhatNgay:"", donGiaTangCaGio:"", donGiaTangCaCnGio:""
      };
      this.donGia.open = true;
      try{
        const { data } = await api.get(`/api/thoivu/luong/by-lao-dong/${row.id}`);
        const cfg = data?.data || {};
        this.donGia.form.donGiaHanhChinhNgay = this.decStr(cfg.donGiaHanhChinhNgay);
        this.donGia.form.donGiaChuNhatNgay   = this.decStr(cfg.donGiaChuNhatNgay);
        this.donGia.form.donGiaTangCaGio     = this.decStr(cfg.donGiaTangCaGio);
        this.donGia.form.donGiaTangCaCnGio   = this.decStr(cfg.donGiaTangCaCnGio);
      }catch{}
    },
    async saveDonGia(){
      if (!this.donGia.ld) return;
      this.saving=true;
      try{
        const p = {
          idThoivuLd: this.donGia.form.idThoivuLd,
          donGiaHanhChinhNgay: this.cleanMoney(this.donGia.form.donGiaHanhChinhNgay),
          donGiaChuNhatNgay:   this.cleanMoney(this.donGia.form.donGiaChuNhatNgay),
          donGiaTangCaGio:     this.cleanMoney(this.donGia.form.donGiaTangCaGio),
          donGiaTangCaCnGio:   this.cleanMoney(this.donGia.form.donGiaTangCaCnGio)
        };
        await api.post("/api/thoivu/luong/upsert", p);
        this.toastOk("Đã lưu cấu hình lương");
        this.donGia.open=false;
      }catch(e){
        console.error(e); this.alertUser("Lưu cấu hình lương lỗi","error");
      }finally{
        this.saving=false;
      }
    },

    // ====== Tài liệu ======
    async openTaiLieu(row){
      this.taiLieu.ld = row;
      this.taiLieu.open = true;
      this.taiLieu.form = { tieuDe:"", ghiChu:"" };
      this.pickedFiles = [];
      await this.loadTaiLieu();
    },
    async loadTaiLieu(){
      try{
        const id = this.taiLieu.ld.id;
        const { data } = await api.get(`/api/thoivu/tai-lieu/by-lao-dong/${id}`);
        this.taiLieu.list = data?.data || [];
      }catch(e){
        console.error(e);
        this.taiLieu.list = [];
      }
    },
    onPickFiles(e){
      this.pickedFiles = Array.from(e.target.files || []);
    },
    async doUpload(){
      if (!this.pickedFiles.length || !this.taiLieu.form.tieuDe){
        this.alertUser("Chọn file & nhập tiêu đề","warning"); return;
      }
      this.uploading=true;
      try{
        const fd = new FormData();
        this.pickedFiles.forEach(f => fd.append("files", f));
        fd.append("folderName","thoivu-tai-lieu");
        const { data:up } = await api.post("/api/images/upload", fd, { headers:{ "Content-Type":"multipart/form-data" } });

        const files = up || [];
        for (const f of files){
          const fileUrl = f.location || f.url || f.fileUrl;
          await api.post("/api/thoivu/tai-lieu", {
            idThoivuLd: this.taiLieu.ld.id,
            tieuDe: this.taiLieu.form.tieuDe,
            fileUrl,
            ghiChu: this.taiLieu.form.ghiChu || null
          });
        }

        await this.loadTaiLieu();
        this.toastOk("Đã tải & lưu tài liệu");
        this.pickedFiles=[];
      }catch(e){
        console.error(e);
        this.alertUser("Upload/lưu tài liệu lỗi","error");
      }finally{
        this.uploading=false;
      }
    },
    async delTaiLieu(d){
      const cfm = await Swal.fire({icon:"warning",title:"Xóa tài liệu?",text:d.tieuDe,showCancelButton:true,confirmButtonText:"Xóa",cancelButtonText:"Hủy"});
      if (!cfm.isConfirmed) return;
      try{
        await api.delete(`/api/thoivu/tai-lieu/${d.id}`);
        await this.loadTaiLieu();
        this.toastOk("Đã xóa");
      }catch(e){
        console.error(e); this.alertUser("Xóa tài liệu lỗi","error");
      }
    },
    preview(d){
      const url = d.fileUrl || "";
      const isImg = /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(url);
      if (isImg){
        this.lightbox = { visible:true, imgs:[url], index:0 };
      }else{
        window.open(url, "_blank");
      }
    },

    // ====== EXPORT EXCEL (Lao động + Lương + Tài liệu) ======
    async exportExcel(){
      try{
        this.exporting = true;

        // 1) Tải toàn bộ list theo filter hiện tại (phân trang)
        const all = await this.fetchAllLaoDong();

        // 2) Cho mỗi LĐ -> lấy cấu hình lương + tài liệu (giới hạn đồng thời 6)
        const enriched = await this.enrichWithLuongAndTaiLieu(all, 6);

        // 3) Build workbook
        const wb = XLSX.utils.book_new();

        // Sheet 1: LaoDong
        const aoaLD = [
          ["DANH SÁCH LAO ĐỘNG THỜI VỤ"],
          [this.exportSubtitle()],
          [],
          ["STT","ID","Họ và tên","SĐT","Trạng thái","Ngày tạo","Ngày sửa","Ghi chú"]
        ];
        enriched.forEach((it, idx) => {
          aoaLD.push([
            idx+1,
            it.id,
            it.hoTen || "",
            it.soDienThoai || "",
            it.trangThai===1 ? "Đang làm" : "Ngưng",
            this.fmtDT(it.ngayTao),
            this.fmtDT(it.ngaySua),
            it.ghiChu || ""
          ]);
        });
        const wsLD = XLSX.utils.aoa_to_sheet(aoaLD);
        this.applySheetStyles(wsLD, { headerRow:3, lastCol:7, titleRows:[0,1] });
        wsLD["!cols"] = [
          {wch:5},{wch:8},{wch:28},{wch:14},{wch:12},{wch:18},{wch:18},{wch:24}
        ];
        this.freezeHeader(wsLD, 4);
        XLSX.utils.book_append_sheet(wb, wsLD, "LaoDong");

        // Sheet 2: Luong
        const aoaL = [
          ["CẤU HÌNH ĐƠN GIÁ (GIÁ THUÊ)"],
          [this.exportSubtitle()],
          [],
          ["ID","Họ và tên","Đơn giá HC/ngày","Đơn giá CN/ngày","Tăng ca/giờ","Tăng ca CN/giờ"]
        ];
        enriched.forEach(it=>{
          const l = it._luong || {};
          aoaL.push([
            it.id,
            it.hoTen || "",
            this.decNum(l.donGiaHanhChinhNgay),
            this.decNum(l.donGiaChuNhatNgay),
            this.decNum(l.donGiaTangCaGio),
            this.decNum(l.donGiaTangCaCnGio),
          ]);
        });
        const wsL = XLSX.utils.aoa_to_sheet(aoaL);
        this.applySheetStyles(wsL, { headerRow:3, lastCol:5, titleRows:[0,1], moneyCols:[2,3,4,5] });
        wsL["!cols"] = [
          {wch:8},{wch:28},{wch:18},{wch:18},{wch:16},{wch:18}
        ];
        this.freezeHeader(wsL, 4);
        XLSX.utils.book_append_sheet(wb, wsL, "Luong");

        // Sheet 3: TaiLieu
        const aoaTL = [
          ["TÀI LIỆU ĐÍNH KÈM"],
          [this.exportSubtitle()],
          [],
          ["LaoĐộngID","Họ và tên","Tiêu đề","File","Ghi chú","Ngày tải"]
        ];
        enriched.forEach(it=>{
          (it._tailieu || []).forEach(tl=>{
            aoaTL.push([
              it.id,
              it.hoTen || "",
              tl.tieuDe || "",
              tl.fileUrl || "",
              tl.ghiChu || "",
              this.fmtDT(tl.ngayTao)
            ]);
          });
          if (!it._tailieu || it._tailieu.length===0){
            aoaTL.push([it.id, it.hoTen || "", "(chưa có)", "", "", ""]);
          }
        });
        const wsTL = XLSX.utils.aoa_to_sheet(aoaTL);
        this.applySheetStyles(wsTL, { headerRow:3, lastCol:5, titleRows:[0,1] });
        wsTL["!cols"] = [
          {wch:10},{wch:28},{wch:28},{wch:50},{wch:24},{wch:18}
        ];
        this.freezeHeader(wsTL, 4);
        XLSX.utils.book_append_sheet(wb, wsTL, "TaiLieu");

        // 4) Save
        const ts = new Date();
        const name = `Thoivu_Export_${ts.getFullYear()}${String(ts.getMonth()+1).padStart(2,'0')}${String(ts.getDate()).padStart(2,'0')}_${String(ts.getHours()).padStart(2,'0')}${String(ts.getMinutes()).padStart(2,'0')}.xlsx`;
        XLSX.writeFile(wb, name);
        this.toastOk("Đã xuất Excel");
      }catch(e){
        console.error(e);
        this.alertUser("Xuất Excel lỗi","error");
      }finally{
        this.exporting = false;
      }
    },

    async fetchAllLaoDong(){
      // lấy tất cả theo filter hiện tại
      const pageSize = 200;
      let page = 0, totalPages = 1;
      const out = [];
      while (page < totalPages){
        const params = {
          keyword: this.filter.keyword || "",
          status: this.filter.status,
          page, size: pageSize
        };
        const { data } = await api.get("/api/thoivu/lao-dong", { params });
        const pg = data?.data;
        out.push(...(pg?.content || []));
        const totalElements = pg?.totalElements ?? out.length;
        totalPages = Math.max(1, Math.ceil(totalElements / pageSize));
        page++;
      }
      return out;
    },

    async enrichWithLuongAndTaiLieu(items, concurrency=6){
      const q = items.slice();
      const result = [];
      const worker = async () => {
        while(q.length){
          const it = q.shift();
          const [luong, tailieu] = await Promise.allSettled([
            api.get(`/api/thoivu/luong/by-lao-dong/${it.id}`),
            api.get(`/api/thoivu/tai-lieu/by-lao-dong/${it.id}`)
          ]);
          it._luong = luong.status==="fulfilled" ? (luong.value?.data?.data || {}) : {};
          it._tailieu = tailieu.status==="fulfilled" ? (tailieu.value?.data?.data || []) : [];
          result.push(it);
        }
      };
      const ps = Array.from({length:Math.max(1,concurrency)}, ()=>worker());
      await Promise.all(ps);
      // giữ nguyên thứ tự theo id tăng dần
      return result.sort((a,b)=> (a.id||0)-(b.id||0));
    },

    // ===== helpers (styles & excel) =====
    exportSubtitle(){
      const parts = [];
      if (this.filter.keyword) parts.push(`Từ khóa: "${this.filter.keyword}"`);
      if (this.filter.status===1) parts.push("Trạng thái: Đang làm");
      else if (this.filter.status===0) parts.push("Trạng thái: Ngưng");
      else parts.push("Trạng thái: Tất cả");
      const now = new Date();
      parts.push(`Xuất lúc: ${now.toLocaleString("vi-VN",{hour12:false})}`);
      return parts.join("  •  ");
    },
    applySheetStyles(ws, { headerRow, lastCol, titleRows=[], moneyCols=[] }){
      const borderAll = {
        top:{style:"thin",color:{rgb:"000000"}},
        left:{style:"thin",color:{rgb:"000000"}},
        bottom:{style:"thin",color:{rgb:"000000"}},
        right:{style:"thin",color:{rgb:"000000"}},
      };
      const center = { horizontal:"center", vertical:"center" };

      // Title rows
      titleRows.forEach(r=>{
        for(let c=0;c<=lastCol;c++){
          this.ensureCell(ws,r,c);
          ws[XLSX.utils.encode_cell({r,c})].s = { font:{bold:true, sz:14}, alignment:center };
        }
        // merge across
        ws["!merges"] = ws["!merges"] || [];
        ws["!merges"].push({ s:{r:r,c:0}, e:{r:r,c:lastCol} });
      });

      // Header row
      for(let c=0;c<=lastCol;c++){
        this.ensureCell(ws, headerRow, c);
        ws[XLSX.utils.encode_cell({r:headerRow,c})].s = { font:{bold:true}, alignment:center, border:borderAll };
      }

      // Body border + align + money format
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let r=headerRow+1; r<=range.e.r; r++){
        for (let c=0; c<=lastCol; c++){
          this.ensureCell(ws, r, c);
          const addr = XLSX.utils.encode_cell({r,c});
          const s = ws[addr].s || {};
          ws[addr].s = { ...s, border:borderAll, alignment:{vertical:"center", horizontal: c===0||c===1 ? "center" : (moneyCols.includes(c)?"right":"left")} };
          if (moneyCols.includes(c)){
            // set number format if numeric
            if (typeof ws[addr].v === "number"){
              ws[addr].z = "#,##0";
            }
          }
        }
      }
    },
    freezeHeader(ws, rowCount=1){
      ws["!freeze"] = { xSplit: "1", ySplit: String(rowCount), topLeftCell: "B2", activePane: "bottomRight", state: "frozen" };
    },
    ensureCell(ws, r, c){
      const addr = XLSX.utils.encode_cell({r,c});
      if (!ws[addr]) ws[addr] = { t:"s", v:"" };
      return ws[addr];
    },
    decNum(v){
      if (v===null || v===undefined || v==="") return "";
      const s = String(v).replace(/\./g,'').replace(/,/g,'').trim();
      const n = Number(s);
      return Number.isFinite(n) ? n : s; // nếu không phải số, để nguyên
    },

    // ===== misc helpers =====
    initials(name){ const n=(name||"").trim().split(/\s+/); return ((n[0]?.[0]||"")+(n[n.length-1]?.[0]||"")).toUpperCase(); },
    fmtDT(dt){ return dt ? new Date(dt).toLocaleString("vi-VN",{hour12:false}) : "—"; },
    shortName(u){ try{ const p=new URL(u); return decodeURIComponent(p.pathname.split('/').pop()); }catch{return (u||'').split('/').pop();} },
    toastOk(msg){ if(this.$toast?.success) this.$toast.success(msg); else alert(msg); },
    alertUser(msg,type="info"){ if(Swal?.fire) Swal.fire({icon:type,title:msg}); else alert(msg); },

    // BigDecimal-safe strings
    decStr(v){ if (v===null || v===undefined) return ""; const s=String(v); return s; },
    cleanMoney(s){ if (s===null || s===undefined) return null; let t=String(s).replace(/\./g,'').replace(/,/g,''); t=t.trim(); return t===""?null:t; },

    // responsive
    onResize(){ this.isMobile = window.matchMedia("(max-width: 768px)").matches; }
  }
};
</script>

<style scoped>
.header-sticky{ position: sticky; top: 0; z-index: 5; background: #fff; padding-top: .5rem; }
.font-weight-600{ font-weight: 600; }

.avatar{ width:28px; height:28px; border-radius:50%; overflow:hidden; display:inline-block; }
.avatar-sm{ width:32px; height:32px; }
.avatar-fallback{ width:100%; height:100%; display:flex; align-items:center; justify-content:center; background:#eee; color:#666; font-weight:700; }

.ld-card{
  background: #fff; border: 1px solid #eee; border-radius: 10px; padding: 12px; margin-bottom: 10px;
  box-shadow: 0 1px 0 rgba(0,0,0,.02);
}
.name-ellipsis{ max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.btn-row .btn{ margin-right: 6px; }

.modal{ background: rgba(0,0,0,.35); }
.modal.custom-modal .modal-content{ max-height: calc(100vh - 1rem); display:flex; flex-direction:column; }
.modal.custom-modal .modal-body{ overflow-y:auto; }

/* Mobile fullscreen modal */
.modal-fullscreen{ max-width: none !important; width: 100%; height: 100%; margin: 0; }
.modal-fullscreen .modal-content{ height: 100%; border-radius: 0; }

@media (max-width: 768px){
  .thoivu-wrapper{ font-size: 13px; }
  .name-ellipsis{ max-width: 140px; }
}
</style>
